<template>
  <div
    class="display-form-field pr-0"
    :class="[`col-${col}`, `fs-${fontSize}`, { '-border': border }, { 'font-weight-bold': bold }]">
    <slot />
  </div>
</template>

<script>
/**
 * @description 自己評価の値を表示する時に使うコンポーネント
 */
export default {
  props: {
    border: {
      type: Boolean,
      default: false
    },
    col: {
      type: [String, Number],
      default: 12
    },
    fontSize: {
      type: String,
      default: 'm'
    },
    bold: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.display-form-field {
  min-height: 48px;
  padding: 12px 0 12px 24px;
  overflow-wrap: anywhere;

  &.-border {
    border: 1px solid $grey11;
  }

  &.fs-xs {
    font-size: $fs-xs;
  }

  &.fs-s {
    font-size: $fs-s;
  }

  &.fs-m {
    font-size: $fs-m;
  }

  &.fs-nm {
    font-size: $fs-nm;
  }

  &.fs-lg {
    font-size: $fs-lg;
  }

  &.fs-xl {
    font-size: $fs-xl;
  }

  &.fs-xxl {
    font-size: $fs-xxl;
  }
}
</style>